import { uiCommonConfig } from './uiCommon.config';
import type { UiConfig } from './uiConfigTypes';

export const uiDevConfig: UiConfig = {
  // DO NOT SPREAD ANY OTHER CONFIG BESIDES THE COMMON CONFIG
  ...uiCommonConfig,

  amplitudeApiKey: 'c1ae52f9614e6c4a8b945d33a56016c6',
  authUrl: 'https://stage-auth.fox.com/foxone/',
  brazeApiKey: '420ca158-5a4d-4139-8df1-5019521cb18a',
  brazeEndpoint: 'sdk.iad-07.braze.com',
  callbackUrl: 'https://fox.com/callback',
  clientId: '14e8bd8d-a78b-48e0-a7ed-4e4a25291142',
  googleTagManagerId: 'GTM-526R8GRC',
  isBrazeLoggingEnabled: false,
  isBrazeCustomLoggingEnabled: false,
  environment: 'dev',
  environmentAlt: 'staging',
  heapAppId: '1342358647',
  helpUrl: 'https://foxone--f1uat.sandbox.my.site.com/help/s/',
  isBrazeEnabled: true,
  isDatadogEnabled: false,
  isGoogleAnalyticsEnabled: false,
  manageAccountUrl: 'https://dev-auth.fox.com/manage/foxone',
  manageSubscriptionUrl: 'https://dev-subs.fox.com/manage',
  planSelectUrl: 'https://dev-subs.fox.com/subscribe',
  planSelectEmployeeUrl: 'https://dev-subs.fox.com/employee',
  playerUrl: 'https://prod.player.fox.digitalvideoplatform.com/wpf/v3/3.2.46/wpf_player.js',
  privacyOrgCode: 'fds',
  subscribeUrl: 'https://dev-subs.fox.com/subscribe',
  withClock: false,
};
